<template lang="pug">
  v-snackbar(
    :color="color" 
    dark 
    top 
    multi-line
    v-model='snackbar'
    :timeout="timeout"
  )
    | {{ text }}
    v-btn(text @click='snackbar = false')
      | OK
</template>

<script>
  export default {
    data: () => ({
      snackbar: false,
      text: '',
      color: "yellow",
      timeout: -1
    }),
    created () {
      this.$bus.$on('snack-err', (err) => {
        this.text = err
        this.color = "red"
        this.snackbar = true
        this.timeout = -1
      })
      this.$bus.$on('snack-info', (info) => {
        this.text = info
        this.color = "green"
        this.snackbar = true
        this.timeout = 2000
      })
    }
  }
</script>